import {useMemo} from 'react';

import {Icon, IconName, IconSize} from 'components';
import {ClientDevice} from 'interfaces';

type Props = {
    device: ClientDevice;
    iconSize?: IconSize;
    className?: string;
};

export const DeviceIcon: React.FC<Props> = ({device, className, iconSize = 'md'}: Props) => {
    const iconOptions = useMemo<{name: IconName}>(() => {
        const loweredOsValue = String(device).toLowerCase();
        const options = {
            name: null,
        };

        if (device === ClientDevice.Sip) {
            options.name = 'device-sip';
        } else if (loweredOsValue === ClientDevice.Phone) {
            options.name = 'device-phone';
        }

        return options;
    }, [device]);

    return (
        iconOptions.name ? <Icon className={className} size={iconSize} {...iconOptions} /> : null
    );
};
